/* Nov 2026 : pages collection. La pagination Shopify brute (1 2 Suivant) est remplacee par un bouton "Voir plus de produits" qui charge la page suivante sous la grille. */
(function () {
  function init() {
    var grid = document.querySelector('.collection ul.grid');
    var next = document.querySelector('.collection .next a');
    if (!grid || !next) return;
    var wrap = next.closest('div') || next.parentNode;
    var st = document.createElement('style');
    st.textContent = '.kq-more-wrap{display:flex;flex-direction:column;align-items:center;gap:8px;padding:10px 16px 28px}.kq-more{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:46px;padding:0 28px;border:1.5px solid #111;border-radius:100px;background:#fff;color:#111;font-family:Inter,Helvetica,Arial,sans-serif;font-size:12.5px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:background .15s,color .15s}.kq-more:hover,.kq-more:active{background:#111;color:#fff}.kq-more:disabled{opacity:.6;cursor:wait}.kq-more-info{margin:0;font-family:Inter,Helvetica,Arial,sans-serif;font-size:11.5px;color:#888}';
    document.head.appendChild(st);
    var url = next.href;
    wrap.innerHTML = '';
    wrap.className = 'kq-more-wrap';
    wrap.removeAttribute('style');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'kq-more'; btn.textContent = 'Voir plus de produits';
    var info = document.createElement('p'); info.className = 'kq-more-info';
    wrap.appendChild(btn); wrap.appendChild(info);
    function count() { var n = grid.children.length; info.textContent = n + ' produits affichés'; }
    count();
    /* Relance uniquement le bloc "ajout rapide" du script de la section (pas le bloc description) pour activer le + sur les nouvelles vignettes. */
    function rerunQuickAdd() {
      var s = [].find.call(document.scripts, function (x) { return x.textContent.indexOf('initQadd') !== -1; });
      if (!s) return;
      var code = s.textContent.split('/* Description de collection')[0];
      try { new Function(code)(); } catch (e) {}
    }
    btn.addEventListener('click', async function () {
      if (!url) return;
      btn.disabled = true; btn.textContent = 'Chargement…';
      try {
        var html = await (await fetch(url, { credentials: 'same-origin' })).text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.collection ul.grid > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var n = doc.querySelector('.collection .next a');
        url = n ? n.href : null;
        rerunQuickAdd();
      } catch (e) {}
      btn.disabled = false; btn.textContent = 'Voir plus de produits';
      count();
      if (!url) btn.remove();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
